import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'hot') return 'ri-fire-fill text-accent-500';
    if (trend === 'new') return 'ri-flashlight-fill text-primary-500';
    return 'ri-arrow-up-fill text-primary-500';
  };

  const getTrendLabel = (trend: string) => {
    if (trend === 'hot') return '爆';
    if (trend === 'new') return '新';
    return '热';
  };

  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-hashtag"></i>
            话题标签
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">热门话题标签</h2>
          <p className="mt-3 text-sm text-foreground-600">点击标签，直达相关爆料内容</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#"
              className="group inline-flex items-center gap-3 bg-background-50 border border-background-200/70 rounded-full pl-4 pr-3 py-2.5 hover:border-primary-300/60 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-2">
                <i className={`${getTrendIcon(topic.trend)} text-sm`}></i>
                <span className="text-sm font-semibold text-foreground-900">{topic.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-accent-600 font-medium">{topic.heat}</span>
                <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full">{topic.posts}条</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}